export default __webpack_public_path__ + "static/media/forwards-button-icon.90e7fc6f.svg";